module.exports = __webpack_public_path__ + "img/play-fill.4e60584d.svg";